import { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import { queryClient } from '@/configs/react-query';
import '@/index.css';
import {
  QueryClientProvider,
  QueryErrorResetBoundary,
} from '@tanstack/react-query';
import 'leaflet/dist/leaflet.css';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { DialogContainer } from './components/dialog';
import LoadingSpin from './components/loadingSpin/LoadingSpin';
import { Toaster } from './components/ui/sonner';
import './i18n';
import { DialogProvider, SidebarProvider } from './providers';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={({ resetErrorBoundary }) => (
            <div>
              There was an error!
              <button onClick={() => resetErrorBoundary()}>Try again</button>
            </div>
          )}
        >
          <Suspense fallback={<LoadingSpin />}>
            <BrowserRouter>
              <QueryClientProvider client={queryClient}>
                <DialogProvider>
                  <SidebarProvider>
                    <App />
                    <Toaster />
                  </SidebarProvider>
                  <DialogContainer />
                </DialogProvider>
              </QueryClientProvider>
            </BrowserRouter>
          </Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  </StrictMode>,
);
